import { Language } from '../i18n';

export const formatCurrency = (
  language: Language,
  amount: number,
  currency: string
) => {
  return new Intl.NumberFormat(language, {
    style: 'currency',
    currency,
  }).format(amount);
};

export const formatNumber = (language: Language, amount: number) => {
  return new Intl.NumberFormat(language).format(amount);
};
